// extracted by mini-css-extract-plugin
export default {"icon":"F_ct_","flipInY":"Xzcdf","title":"RrzSp","text":"nTBgh"};